const routes = [
  {
    path: '/login',
    component: () => import('../layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import('../views/Auth/Login.vue')
      }
    ]
  },
  {
    path: '/forgot-password',
    component: () => import('../layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'ForgotPassword',
        component: () => import('../views/Auth/ForgotPassword.vue')
      }
    ]
  },
  {
    path: '/reset-password',
    component: () => import('../layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'ResetPassword',
        component: () => import('../views/Auth/ResetPassword.vue')
      }
    ]
  },
  {
    path: '/',
    component: () => import('../layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    redirect: { name: 'Dashboard' },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard/Dashboard.vue')
      },
      {
        path: '/alerts',
        name: 'Alerts',
        component: () => import('../views/Alerts/Alerts.vue')
      },
      {
        path: '/subscribers',
        name: 'Subscribers',
        component: () => import('../views/Subscribers/Subscribers.vue')
      },
      {
        path: '/plans',
        name: 'Plans',
        component: () => import('../views/Plans/Plans.vue')
      },
      {
        path: '/sites',
        name: 'Sites',
        component: () => import('../views/Sites/Sites.vue')
      },
      {
        path: '/settings',
        name: 'Settings',
        component: () => import('../views/Settings/Settings.vue')
      },
      {
        path: '/advertisers',
        name: 'Advertisers',
        component: () => import('../views/Advertisers/Advertisers.vue')
      },
      {
        path: '/advertisers/:id/details',
        name: 'AdvertiserDetails',
        component: () => import('../views/Advertisers/AdvertiserDetails.vue')
      },
      {
        path: '/sites/:id/:tab?',
        name: 'SitesDetails',
        component: () => import('../views/Sites/SitesDetails.vue')
      },
      {
        path: '/audit-log',
        name: 'AuditLog',
        component: () => import('../views/AuditLog/AuditLog.vue')
      },
      {
        path: '/commissions',
        name: 'Commissions',
        component: () => import('../views/Commissions/Commissions.vue')
      },
      {
        path: '/companies',
        name: 'Companies',
        component: () => import('../views/Companies/Companies.vue')
      },
      {
        path: '/companies/:id',
        name: 'CompanyDetails',
        component: () => import('../views/Companies/CompanyDetails.vue')
      },
      {
        path: '/users',
        name: 'Users',
        component: () => import('../views/Users/Users.vue')
      },
      {
        path: '/users/:id',
        name: 'UserDetails',
        component: () => import('../views/Users/Users.vue')
      },
      {
        path: '/report/commission',
        name: 'CommissionsReport',
        component: () => import('../views/Report/Commissions.vue')
      },
      {
        path: '/report/other-commission',
        name: 'OtherCommissionsReport',
        component: () => import('../views/Report/OtherCommissions.vue')
      },
      {
        path: '/report/publisher-payment',
        name: 'PublisherPaymentReport',
        component: () => import('../views/Report/PublisherPayment.vue')
      },
      {
        path: '/report/ads-txt',
        name: 'AdsTxt',
        component: () => import('../views/Report/AdsTxt.vue')
      },
      {
        path: '/report/miscellaneous',
        name: 'Miscellaneous',
        component: () => import('../views/Report/Miscellaneous.vue')
      },
      {
        path: '/report/account-receivable',
        name: 'AccountReceivable',
        component: () => import('../views/Report/AccountReceivable.vue')
      },
      {
        path: '/report/publisher-earnings',
        name: 'PublisherEarningsReport',
        component: () => import('../views/Report/PublisherEarnings.vue')
      },
      {
        path: '/report/traffic',
        name: 'TrafficReport',
        component: () => import('../views/Report/Traffic.vue')
      },
      {
        path: '/subscription-revenue-report',
        name: 'SubscriptionRevenue',
        component: () => import('../views/SubscriptionRevenue/SubscriptionRevenue.vue')
      },
      {
        path: '/advertisers-report',
        name: 'AdvertisersReport',
        component: () => import('../views/AdvertisersReport/AdvertisersReport.vue')
      },
      {
        path: '/messages',
        name: 'Messages',
        component: () => import('../views/Messages/Messages.vue')
      },
      {
        path: '/site-tags',
        name: 'Site Tags',
        component: () => import('../views/SiteTags/SiteTags.vue')
      },
      {
        path: '/localization',
        name: 'Localization',
        component: () => import('../views/Localization/Localization.vue')
      },
      {
        path: '/charges',
        name: 'Charges',
        component: () => import('../views/Charges/Charges.vue')
      },
      {
        path: '/mycompany',
        name: 'MyCompany',
        meta: { publisherOnly: true },
        component: () => import('../views/Companies/CompanyDetails.vue')
      },
      {
        path: '/reporting-events',
        name: 'ReportingEvents',
        meta: { adOpsOnly: true },
        component: () => import('../views/ReportingEvents/ReportingEvents.vue')
      },
    ]
  }
]

export default routes
